import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

/**
 * ModernPagination - A SaaS-style pagination component.
 */
const ModernPagination = ({ currentPage, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;

    const goToPage = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            onPageChange(newPage);
        }
    };

    // Generate page numbers to display
    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        let start = Math.max(0, currentPage - Math.floor(maxVisible / 2));
        let end = Math.min(totalPages - 1, start + maxVisible - 1);

        if (end - start < maxVisible - 1) {
            start = Math.max(0, end - maxVisible + 1);
        }

        for (let i = start; i <= end; i++) {
            pages.push(i);
        }
        return pages;
    };

    return (
        <div className="flex items-center justify-center gap-1.5">
            {/* First Page */}
            <button
                onClick={() => goToPage(0)}
                disabled={currentPage === 0}
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-slate-200 text-slate-500 hover:bg-slate-50 hover:border-blue-300 disabled:opacity-40 disabled:cursor-not-allowed transition-all shadow-sm"
                title="Première page"
            >
                <ChevronsLeft size={16} />
            </button>

            {/* Previous Page */}
            <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 0}
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-slate-200 text-slate-500 hover:bg-slate-50 hover:border-blue-300 disabled:opacity-40 disabled:cursor-not-allowed transition-all shadow-sm"
                title="Page précédente"
            >
                <ChevronLeft size={16} />
            </button>

            {/* Page Numbers */}
            {getPageNumbers().map((pageNum) => (
                <button
                    key={pageNum}
                    onClick={() => goToPage(pageNum)}
                    className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all shadow-sm
                        ${currentPage === pageNum
                            ? 'bg-blue-600 text-white border border-blue-600'
                            : 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50 hover:border-blue-300'
                        }`}
                >
                    {pageNum + 1}
                </button>
            ))}

            {/* Next Page */}
            <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage >= totalPages - 1}
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-slate-200 text-slate-500 hover:bg-slate-50 hover:border-blue-300 disabled:opacity-40 disabled:cursor-not-allowed transition-all shadow-sm"
                title="Page suivante"
            >
                <ChevronRight size={16} />
            </button>

            {/* Last Page */}
            <button
                onClick={() => goToPage(totalPages - 1)}
                disabled={currentPage >= totalPages - 1}
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-slate-200 text-slate-500 hover:bg-slate-50 hover:border-blue-300 disabled:opacity-40 disabled:cursor-not-allowed transition-all shadow-sm"
                title="Dernière page"
            >
                <ChevronsRight size={16} />
            </button>
        </div>
    );
};

export default ModernPagination;
